// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-contact-js": () => import("C:\\Users\\Jan\\Desktop\\Jan\\projects\\3#Gatsby\\src\\pages\\contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\Jan\\Desktop\\Jan\\projects\\3#Gatsby\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-projects-js": () => import("C:\\Users\\Jan\\Desktop\\Jan\\projects\\3#Gatsby\\src\\pages\\projects.js" /* webpackChunkName: "component---src-pages-projects-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "C:\\Users\\Jan\\Desktop\\Jan\\projects\\3#Gatsby\\.cache\\data.json")

